PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
track = require 'debug/track'

t = require('views/internal/teacup-with-helpers')('org_filtering')
template = t.renderable ({ name, isDeleteable }) ->

  t.form '.js-add-tag-form', ->
    t.label ->
      t.format 'name'
      t.input '.js-add-tag-name.js-autofocus', type: 'text', value: name
    t.input '.primary', type: 'submit', value: t.l('save')
    if isDeleteable
      t.button '.negate.u-float-right.js-delete-tag', type: 'button', ->
        t.format 'delete'

module.exports = class SetTagView extends View
  events:
    'submit .js-add-tag-form': (e) ->
      e.preventDefault()
      if @options.boardView
        track('Board Menu', 'Collections Menu', 'Save New Collection')
      else
        track('Team Page', 'Collections Menu', 'Save New Collection')
      name = @$('.js-add-tag-name').val().trim()
      @onSubmit(name)
      return
    'click .js-delete-tag': (e) ->
      Util.stop(e)
      @onDelete()
      return

  getName: -> ''

  render: ->
    @$el.html template(name: @getName(), isDeleteable: @onDelete?)

    @



// WEBPACK FOOTER //
// ./app/scripts/views/organization/set-tag-view.coffee